import { themeColors } from '@/styles/theme';
import React from 'react';

const AutomationIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className || "w-6 h-6"}>
    <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke={themeColors.iconMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 7H14V16H17V7Z" stroke={themeColors.iconMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 7H7V12H10V7Z" stroke={themeColors.iconMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default AutomationIcon;
